export default {
    props: {
        schemaModel: {
            type: Object,
            default: undefined,
            kComposite: 'schema.model'
        },
        schemaAggregates: {
            type: [Function, String],
            default: undefined,
            kComposite: 'schema.aggregates'
        },
        schemaData: {
            type: [Function, String],
            default: undefined,
            kComposite: 'schema.data'
        },
        schemaErrors: {
            type: [Function, String],
            default: undefined,
            kComposite: 'schema.errors'
        },
        schemaGroups: {
            type: [Function, String],
            default: undefined,
            kComposite: 'schema.groups'
        },
        schemaModelId: {
            type: String,
            default: undefined,
            kComposite: 'schema.model.id'
        },
        schemaModelFields: {
            type: Object,
            default: undefined,
            kComposite: 'schema.model.fields'
        },
        schemaParse: {
            type: Function,
            default: undefined,
            kComposite: 'schema.parse'
        },
        schemaTotal: {
            type: [Function, String],
            default: undefined,
            kComposite: 'schema.total'
        },
        schemaType: {
            type: String,
            default: undefined,
            kComposite: 'schema.type'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-datasource-vue-wrapper/src/KendoTreeListDataSource/Schema.js